<template>
    <div class="switch-city" v-if="isVisiable">
        <h3>{{title}}</h3>
        <p class="locate-city">
            <slot>
                <p v-if="!useHTMLString" v-html="showText" class="locate-city"></p>
                <p v-else v-html="showHtml"></p>
            </slot>
        </p>
        <div class="switch-btn-box">
            <div @click="closeFn()">{{cancelButtonText}}</div>
            <div @click="switchFn()">{{confirmButtonText}}</div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            background: false,
            visible: false,
            title: '是否切换城市',
            message: '定位到您在{cityName}',
            useHTMLString: false,
            cancelButtonText: '取消',
            confirmButtonText: '切换',
            cityName: '',
        }
    },
    computed:{
        isVisiable(){
            return !this.background && this.visible;
        },
        showText(){
           return this.message.replace('{cityName}',`<img class="locate_icon" style=" display:inline-block;width: 4%;" src="//file.40017.cn/img140017cnproduct/cn/c/topic/newguest/locate_icon.png" alt=""> ${this.cityName}`)
        },
        showHtml(){
             return this.message.replace('{cityName}', this.cityName)
        }
    },
}
</script>
<style scoped>
.switch-city {
    position: fixed;
    z-index: 100;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    width: 70%;
    padding: 18px;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 5px;
    color: #333;
    font-size: 14px;
    text-align: left;
    box-shadow: 1px 1px 3px 2px #ccc;
}
.locate-city {
    margin: 18px 0;
}

.switch-btn-box {
    float: right;
}
.switch-btn-box div {
    display: inline-block;
    margin-left: 30px;
}
</style>
